<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" class="p-0">
          <TopBarMember class="mb-0 mb-sm-3" />
        </b-col>
      </b-row>
    </b-container>
    <b-container class="px-0 px-sm-3 overflow-hidden">
      <b-card
        header-bg-variant="dark"
        header-border-variant="dark"
        header-text-variant="white"
        header-tag="header"
        body-bg-variant="light"
        border-variant="dark"
        class="main-card"
        body-class="p-2"
      >
        <template #header class="card-header px-0">
          <router-link to="/member/poy">
            <i class="fas fa-chevron-left"></i> โพยหวย
          </router-link>
        </template>
        <b-row class="mb-2">
          <b-col>
            <b-card body-class="py-1 px-2" class="shadow-sm" border-variant="white">
              <b-row>
                <b-col class="mt-1" cols="12" sm="6" md="6">
                  <h5 class="m-0">
                    <i class="fas fa-receipt"></i> รายละเอียดโพย
                  </h5>
                </b-col>
                <b-col class="text-right" cols="12" sm="6" md="6">
                  <b-btn
                    variant="outline-warning"
                    class="gold-btn"
                    size="sm"
                    @click="cancelTicket"
                    v-if="betResult.status == 1 || betResult.status == '1'"
                  >คืนโพย</b-btn>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <b-card
              border-variant="secondary"
              header-bg-variant="secondary"
              header-text-variant="white"
              header-class="text-center font-weight-bold p-2"
              body-class="py-2 px-3"
            >
              <template #header>
                <i class="fas fa-sticky-note"></i>
                โพยเลขที่ #{{betResult.ticketNo}}
              </template>

              <b-row>
                <b-col
                  class="border-bottom py-1 d-flex flex-row justify-content-between justify-content-sm-between justify-content-md-start align-items-center"
                  sm="12"
                  md="6"
                >
                  <!-- <b-badge class="mr-1">{{getLottoType.filter( i => getLottoType.includes( i.lottoType ))[0]}}</b-badge> -->
                  <span class="badge font-weight-light">วันที่: {{ formatDate(betResult.pingPongDate, "DD/MM/YYYY HH:mm") }}<span v-if="type == 1 || type == '1' || type == 2 || type == '2'"> รอบที่: {{betResult.roundNumber}}</span></span>
                </b-col>
                <b-col
                  class="py-1 border-bottom text-secondary text-center text-sm-center text-md-right"
                  sm="12"
                  md="6"
                >
                  <small class="mr-1">ทำรายการเมื่อ</small>
                  <span class="badge">
                    <i class="far fa-calendar-alt"></i> {{ formatDate(betResult.createdDate, "DD/MM/YYYY") }}
                  </span>
                  <span class="badge">
                    <i class="far fa-clock"></i> {{ formatDate(betResult.createdDate, "HH:mm") }}
                  </span>
                </b-col>
                <b-col classs="px-0">
                  <div class="pl-1 pr-0 text-center w-100">
                    <small>ยอดแทง</small>
                    <h5 class="font-weight-light text-primary font-number">฿ {{betResult.totalBet}}</h5>
                  </div>
                </b-col>
                <b-col classs="px-0">
                  <div class="pr-1 pl-0 text-center border-left w-100">
                    <small>ผลได้เสีย</small>
                    <h5 class="font-weight-light font-number">฿ {{betResult.totalWon !== null && betResult.totalWon !== "" ? betResult.totalWon : '0'}}</h5>
                  </div>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="12" sm="6" md="4" class="mb-3" v-for="(item, index) in betResult.betSlot" v-bind:key="index">
            <b-card
              border-variant="secondary"
              header-bg-variant="white"
              header-class="p-0 d-flex align-items-stretch card-poy-header"
              body-class="py-0 px-3"
              footer-class="m-0 px-2 pt-1 pb-1 d-flex justify-content-between"
            >
              <template #header>
                <div class="d-flex flex-column justify-content-center py-1 px-2">
                  <h6 class="mb-0">
                    <small>ลำดับที่</small>
                    {{(index + 1)}}
                  </h6>
                </div>
                <div class="ml-auto d-flex">
                  <!-- <div class="flex-fill poy-status unsuccess py-1 px-2">รอออกผล</div> -->
                  <div class="flex-fill poy-status unsuccess py-1 px-2 bg-warning" v-if="betResult.status == 1 || betResult.status == '1'">รอออกผล</div>
                  <div class="flex-fill poy-status unsuccess py-1 px-2 bg-success text-white" v-if="(betResult.status > 1 || betResult.status > '1') && item.isWon">ถูกรางวัล</div>
                  <div class="flex-fill poy-status unsuccess py-1 px-2 bg-light" v-if="(betResult.status > 1 || betResult.status > '1') && !item.isWon">ไม่ถูกรางวัล</div>
                  <div class="flex-fill poy-status unsuccess py-1 px-2 bg-light" v-if="betResult.status == 4 || betResult.status == '4'">ยกเลิก</div>
                </div>
              </template>
              <b-row>
                <b-col class="m-0 p-1">
                  <div class="poy-type text-center">
                    <h3 class="text-primary mb-0">{{item.betNumber}}</h3>
                    <small v-if="item.betNumberType == 1">สามตัวบน</small>
                    <small v-if="item.betNumberType == 2">สามตัวโต๊ด</small>
                    <small v-if="item.betNumberType == 3">สองตัวบน</small>
                    <small v-if="item.betNumberType == 4">สองตัวโต๊ด</small>
                    <small v-if="item.betNumberType == 5">วิ่งบน</small>
                    <small v-if="item.betNumberType == 6">สองตัวล่าง</small>
                    <small v-if="item.betNumberType == 7">วิ่งล่าง</small>
                    <small v-if="item.betNumberType == 8">สามตัวล่าง</small>
                    <small v-if="item.betNumberType == 9">สามตัวหน้า</small>
                  </div>
                </b-col>
                <b-col class="m-0 pt-2 pb-1 px-1 border-left">
                  <div class="d-flex justify-content-between border-bottom">
                    <small>เลขที่ออก</small>
                    <span class="number-win" v-if="item.betNumberType == 1">
                      {{betResult.topThreeNumber}}
                    </span>
                    <span class="number-win" v-if="item.betNumberType == 2">
                      {{betResult.topThreeNumber}}
                    </span>
                    <span class="number-win" v-if="item.betNumberType == 3">
                      {{betResult.topThreeNumber}}
                    </span>
                    <span class="number-win" v-if="item.betNumberType == 4">
                      {{betResult.downTwoNumber}}
                    </span>
                    <span class="number-win" v-if="item.betNumberType == 5">
                      {{betResult.topThreeNumber}}
                    </span>
                    <span class="number-win" v-if="item.betNumberType == 6">
                      {{betResult.downTwoNumber}}
                    </span>
                    <span class="number-win" v-if="item.betNumberType == 7">
                      {{betResult.downTwoNumber}}
                    </span>
                    <span class="number-win" v-if="item.betNumberType == 8">
                      {{betResult.downThreeNumber}}
                    </span>
                    <span class="number-win" v-if="item.betNumberType == 9">
                      {{betResult.frontThreeNumber}}
                    </span>
                  </div>
                  <div class="d-flex pt-2 justify-content-between">
                    <small>ราคาจ่าย</small>
                    <span>
                      <span class="thb">฿ {{item.payPrice !== null && item.payPrice !== "" ? item.payPrice : ''}}</span>
                    </span>
                  </div>
                </b-col>
              </b-row>
              <template #footer>
                <div class="d-flex">
                  <small class="mr-2">ราคาแทง:</small>
                  <span class="thb">฿ {{item.betPrice}}</span>
                </div>
                <div class="d-flex">
                  <small class="mr-2">ผลได้เสีย:</small>
                  <h5 class="thb mb-0 text-secondary">฿ {{item.wonPrice !== null && item.wonPrice !== "" ? item.wonPrice : ''}}</h5>
                </div>
              </template>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
    </b-container>
    <FooterIndex class="mt-3" />
  </div>
</template>

<script>

// Include Component
import TopBarMember from "@/components/TopBarMember.vue";
import FooterIndex from "@/components/Footer.vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";

export default {
  name: 'PoyDetail',
  props: ['id', 'type', 'lottoType'],
  components: {
    TopBarMember,
    FooterIndex
  },
  data() {
    return {
      typeSelected: {
        code: "ALL",
        title: "หวยทั้งหมด"
      },
      poyTabSelected: "all",
      betResult: []
    };
  },
  mounted() {
    this.getMyTicket();
    console.log(this.getLottoType);
  },
  methods: {
    cancelTicket() {
      this.$bvModal.msgBoxConfirm('คุณต้องการคืนโพยเลขที่ #' + this.betResult.ticketNo + ' ใช่หรือไม่?', {
        title: 'ข้อความแจ้งเตือน',
        okVariant: 'warning',
        okTitle: 'ยืนยัน',
        cancelTitle: 'ยกเลิก',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if(value) {
            axios.post(this.getApiUrl + "/pingpong/cancelmyticket",
              {
                lottoType: parseInt(this.lottoType),
                customerPlayID: this.id,
                username: this.getUsername
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  "token": this.getAccessToken,
                  "username": this.getUsername
                }
              })
              .then(response => {
                this.getMyTicket();
              });
          }
        })
    },
    formatDate(datetime,format) {
      return moment(String(datetime)).format(format);
    },
    getMyTicket() {
      axios.post(this.getApiUrl + "/" + this.type + "/getmyticketdetail",
        {
          // lottoType: this.lottoType,
          customerPlayID: this.id,
          username: this.getUsername
        },
        {
          headers: {
            "Content-Type": "application/json",
            "token": this.getAccessToken,
            "username": this.getUsername
          }
        })
        .then(response => {
          this.betResult = response.data.data;
          console.log('get ticket', response);
        });
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getLottoType: "getLottoType",
      getApiUrl: "getApiUrl"
    })
  }
}
</script>

<style lang="scss" scoped>

.main-card {
  min-height: calc((100vh - 104px) - 49px);
}

.card-poy-header {
  border-bottom: #343a40 1px solid;
  background-color: rgba(235, 235, 235, 0.8);
  line-height: 1;
}

.poy-type {
  font-weight: lighter;
  padding: 5px;
  border-radius: 3px;
  line-height: 1.2;
  text-align: right;
  background: #eee;
  color: #000;

  h3 {
    font-family: "Mitr", sans-serif;
  }
}

.poy-status {
  width: 100%;
  padding: 2px 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;

  &.unsuccess {
    background-color: #ffc107;
  }
}

.gold-btn {
  color: #b47e18 !important;
  border-color: #bd841b !important;

  &:hover {
    color: #fff !important;
    background-color: #b47e18 !important;
    border-color: #bd841b !important;
  }
}

.font-number {
  font-family: "Gugi", cursive;
}

.nav-tabs {
  border-color: #333;
  border-bottom: none;

  .nav-link {
    border-bottom: 1px solid #333;

    &:hover {
      border-bottom: 1px solid #333;
    }

    &.active {
      border-color: #333;
      border-bottom: none;
    }
  }
}

.poylist-item {
  color: #000;

  span:last-child {
    color: #b68800;
  }

  span {
    padding-right: 2px;
    @media screen and (max-width: 767.98px) {
      display: block;
      font-size: 85%;
    }
  }

  &.active {
    background: url(../../assets/images/silver-pattern2.jpeg) top center;
    background-size: 100%;
  }
}

.tab-pane {
  border: 1px solid #333;
  border-top: none;
}

// a.nav-link {
//   background: url(../../assets/images/silver-pattern.jpg) top center;
//   background-size: 100%;
// }

.card-header {
  font-size: 90%;
  line-height: 90%;

  a {
    color: #bbbbbb;

    &:hover {
      color: #bd841b;
      text-decoration: none;
    }
  }
}

.header-line {
  line-height: 25px;
}

.body-line {
  line-height: 40px;
  font-family: "Gugi", cursive;
}

.bg-gray {
  background-color: #d6d8db;
}

.text-border-number {
  text-shadow: #fff 2px 0px 0px, #fff 1.75517px 0.958851px 0px,
    #fff 1.0806px 1.68294px 0px, #fff 0.141474px 1.99499px 0px,
    #fff -0.832294px 1.81859px 0px, #fff -1.60229px 1.19694px 0px,
    #fff -1.97998px 0.28224px 0px, #fff -1.87291px -0.701566px 0px,
    #fff -1.30729px -1.5136px 0px, #fff -0.421592px -1.95506px 0px,
    #fff 0.567324px -1.91785px 0px, #fff 1.41734px -1.41108px 0px,
    #fff 1.92034px -0.558831px 0px;
  letter-spacing: 0.04em;
}

h5 {
  color: #bd841b;
  font-weight: bold;
}

.goldpattern {
  background-size: 100%;
  background: url(../../assets/images/gold-pattern.jpg) top center;
}

.silverpattern {
  background: url(../../assets/images/silver-pattern.jpg) top center;
  background-size: 100%;
}

.credit-balance {
  background-color: #d4edda !important;
  border-color: #c3e6cb;
  font-size: 30px;
  line-height: 40px;
  height: 48px;

  :focus {
    outline: none;
  }
}
</style>